export default __webpack_public_path__ + "static/media/kit_svg2.b5ff8bc5.svg";